import React from "react";
import { FormControlLabel, Typography } from "@mui/material";
import { Checkbox } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { Columns, Inline } from "components/layout/reusableLayouts";
import { PANE_BORDER, PANE_PADDING_X, PANE_TRACKS } from "./paneLayout";

interface PoliciesToolbarProps {
  isAllSelected: boolean;
  disabled: boolean;
  onToggleAll: () => void;
}

/** The column headings, with select-all sitting over the category pane. */
const PoliciesToolbar: React.FC<PoliciesToolbarProps> = ({
  isAllSelected,
  disabled,
  onToggleAll,
}) => {
  const { t } = useTranslation();

  return (
    <Columns
      count={PANE_TRACKS}
      gap="0"
      sx={{
        px: PANE_PADDING_X,
        py: "var(--space-4)",
        alignItems: "center",
        borderBottom: PANE_BORDER,
      }}
    >
      <Typography variant="label">{t("User role")}</Typography>
      <Typography variant="label">{t("Policy")}</Typography>
      <Inline
        gap="var(--space-3)"
        wrap={false}
        align="center"
        justify="between"
      >
        <Typography variant="label">{t("Category")}</Typography>
        <FormControlLabel
          sx={{ marginRight: 0 }}
          control={
            <Checkbox
              checked={isAllSelected}
              onChange={(e) => {
                onToggleAll();
                e.stopPropagation();
              }}
              disabled={disabled}
            />
          }
          label={<Typography variant="label">{t("Select all")}</Typography>}
        />
      </Inline>
    </Columns>
  );
};

export default PoliciesToolbar;
